import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import ExternalRedirect from './ExternalRedirect'

@inject('user')
@observer
class PrivateRoute extends Component {
  componentDidMount () {
    const { user } = this.props
    user.getProfile()
  }
  render () {
    const { component: Component, user, ...rest } = this.props
    const { loading, profile } = user
    if (loading) {
      return <div>Loading...</div>
    }
    // console.log({ loading, profile })
    // const authenticated = user.initUser() && user._id
    return (
      <Route {...rest} render={props =>
        profile
          ? <Component {...props} />
          // : <Component {...props} />
          : <ExternalRedirect to={`${process.env.REACT_APP_GLUU_AUTH_URL}`} />
      }
      />
    )
  }
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js